import { AvatarGroup, Stack, type StackProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import type { FC } from "react";

//TODO:
// Mutalised styles with PrescriptionTableRow
const PREFIX = "PrescriptionTableRow";

export const classes = {
  root: `${PREFIX}-root`,
  header: `${PREFIX}-header`,
  cell: `${PREFIX}-cell`,
  status: `${PREFIX}-status`,
  candidate: `${PREFIX}-candidate`,
  phone: `${PREFIX}-phone`,
  place: `${PREFIX}-place`,
  accompaniement: `${PREFIX}-accompaniement`,
  author: `${PREFIX}-author`,
  prescriptionDate: `${PREFIX}-prescriptionDate`,
  action: `${PREFIX}-action`,
  avatarGroup: `${PREFIX}-avatarGroup`,
  prescription: `${PREFIX}-prescription`,
  document: `${PREFIX}-document`,
};

interface IIntegratedCandidatesTableRowProps extends StackProps {
  hasVisualizeCandidatePermission?: boolean;
  isAuthorizedArchive?: boolean;
}

export const IntegratedTableRow = styled<FC<IIntegratedCandidatesTableRowProps>>(Stack)(
  ({ theme, hasVisualizeCandidatePermission, isAuthorizedArchive }) => ({
    [`& .${classes.root}`]: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      ...(!isAuthorizedArchive
        ? { paddingTop: theme.spacing(2), paddingBottom: theme.spacing(2) }
        : { paddingTop: theme.spacing(1), paddingBottom: theme.spacing(1) }),
      [`&.${classes.header}`]: {
        paddingTop: 0,
        paddingBottom: !isAuthorizedArchive ? theme.spacing(1) : theme.spacing(0),
      },
      [`&:not(.${classes.header}):hover`]: {
        backgroundColor: "rgba(0, 0, 0, 0.04)",
        boxShadow: "-4px 0 0 0 rgba(0, 0, 0, 0.04), 4px 0 0 0 rgba(0, 0, 0, 0.04)",
      },
      [`& .${classes.cell}`]: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        marginLeft: theme.spacing(1),
      },
      [`& .${classes.candidate}`]: {
        flex: "0 0 15%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        cursor: hasVisualizeCandidatePermission ? "pointer" : "unset",
        [theme.breakpoints.down("desktop")]: {
          flex: "0 0 20%",
        },
      },
      [`& .${classes.phone}`]: {
        flex: "0 0 15%",
        [theme.breakpoints.down("desktop")]: {
          flex: "0 0 20%",
        },
      },
      [`& .${classes.place}`]: {
        flex: "0 0 10%",
      },
      [`& .${classes.status}`]: {
        flex: "0 0 10%",
        overflow: "hidden",
        [theme.breakpoints.down("desktop")]: {
          flex: "0 0 20%",
        },
      },
      [`& .${classes.accompaniement}`]: {
        flex: "0 0 15%",
        overflow: "hidden",
      },
      [`& .${classes.author}`]: {
        flex: "0 0 5%",
        overflow: "hidden",
      },
      [`& .${classes.prescriptionDate}`]: {
        flex: "0 0 10%",
        overflow: "hidden",
        [theme.breakpoints.down("desktop")]: {
          flex: "0 0 20%",
        },
      },
      [`& .${classes.prescription}`]: {
        flex: "0 0 10%",
      },
      [`& .${classes.document}`]: {
        textDecoration: "underline",
        overflow: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer",
      },
    },
  })
);

export const UserChipStyled = styled(AvatarGroup)(({ theme }) => ({
  [`&.${classes.avatarGroup}`]: {
    gap: theme.spacing(1),
    justifyContent: "start",
    "& .MuiAvatarGroup-avatar": {
      ...theme.typography.body1,
      backgroundColor: theme.palette.primary.main,
      width: theme.spacing(3),
      height: theme.spacing(3),
      margin: 0,
      border: 0,
    },
  },
}));
